export default ctx => {
  if (navigator.onLine) return
  const { path } = ctx.route
  if (
    path === '/' ||
    path.startsWith('/offline') ||
    path.startsWith('/pesquisa') ||
    (path.startsWith('/coaching') && ctx.store.state.coaching.current)
  )
    return
  ctx.redirect('/offline')
}
